import React from 'react';
import { HelpCircle, MessageCircle, FileText, ChevronDown } from 'lucide-react';

const HelpSupport = () => {
  const faqs = [
    { q: "How to find a tutor?", a: "Go to the 'Find a Tutor' page and use filters to search by subject, syllabus, or area." },
    { q: "How can I view or download past papers?", a: "Navigate to your syllabus, select 'Past Papers', then use View PDF to preview the paper or Download to save it to your device." },
    { q: "Is the shop content physical or digital?", a: "It depends on the product. Some are printed books, and others are downloadable PDFs." }
  ];

  return (
    <div className="max-w-4xl mx-auto px-6 py-12">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-accentBlue mb-4">Help & Support</h2>
        <p className="text-gray-400">Everything you need to know about using our platform.</p>
      </div>

      {/* FAQ Section [cite: 198] */}
      <div className="space-y-4 mb-16">
        <h3 className="text-xl font-bold mb-6 flex items-center gap-2">
          <HelpCircle className="text-accentBlue" /> Frequently Asked Questions
        </h3>
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white/5 border border-white/10 p-6 rounded-2xl">
            <h4 className="font-bold mb-2 flex justify-between items-center text-accentBlue">
              {faq.q} <ChevronDown size={18} />
            </h4>
            <p className="text-sm text-gray-400 leading-relaxed">{faq.a}</p>
          </div>
        ))}
      </div>

      {/* Support Options [cite: 201, 202] */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white/5 border border-white/10 p-8 rounded-[32px] text-center hover:border-accentBlue/30 transition">
          <MessageCircle className="mx-auto text-accentBlue mb-4" size={32} />
          <h4 className="font-bold mb-2">Live Support</h4>
          <p className="text-xs text-gray-500 mb-4">Chat with us via WhatsApp or Messenger for instant help.</p>
          <a href="https://wa.me/94771866626" target="_blank" rel="noopener noreferrer" className="text-accentBlue text-sm font-bold">CONTACT NOW</a>
        </div>
        <div className="bg-white/5 border border-white/10 p-8 rounded-[32px] text-center hover:border-accentBlue/30 transition">
          <FileText className="mx-auto text-accentBlue mb-4" size={32} />
          <h4 className="font-bold mb-2">Policy Pages</h4>
          <p className="text-xs text-gray-500 mb-4">Read our Terms of Service and Privacy Policy.</p>
          <button className="text-accentBlue text-sm font-bold">VIEW POLICIES</button>
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;
